export const description_min_rows = 5;
export const lite_description_min_rows = 3;
